/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Footer_Build_DateInputs */

const en_footer_build_date = /** @type {(inputs: Footer_Build_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build of ${i?.date}`)
};

const fr_footer_build_date = /** @type {(inputs: Footer_Build_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build du ${i?.date}`)
};

const ms_sg2_footer_build_date = /** @type {(inputs: Footer_Build_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Binaan ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Build of {date}" |
*
* @param {Footer_Build_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const footer_build_date = /** @type {((inputs: Footer_Build_DateInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Build_DateInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_build_date(inputs)
	if (locale === "fr") return fr_footer_build_date(inputs)
	return ms_sg2_footer_build_date(inputs)
});